/// <amd-module name="FeedTest/Utils/Identity" />
import { IIdentity } from "VSS/Features/Identities/IdentityService";

export function createIdentity(entityId: string, displayName?: string): IIdentity {
    return {
        entityId,
        entityType: "someIdentity",
        originDirectory: "someDirectory",
        originId: "someId",
        displayName: displayName || entityId
        // mail?: string;
        // localDirectory?: string;
        // localId?: string;
        // scopeName?: string;
        // department?: string;
        // jobTitle?: string;
        // mailNickname?: string;
        // physicalDeliveryOfficeName?: string;
        // signInAddress?: string;
        // subjectDescriptor?: string;
        // surname?: string;
        // guest?: boolean;
        // active?: boolean;
        // description?: string;
        // image?: string;
        // manager?: string;
        // samAccountName?: string;
        // telephoneNumber?: string;
        // isMru?: boolean;
        // isHosted?: boolean;
    } as IIdentity;
}
